import { PureComponent } from 'react'
import style from './Toast.css'

import { Icon } from '@vzmi/shp_shared_compo'
import { domUtil } from '@vzmi/component_ec_nodejs_util'
const { addClass, removeClass } = domUtil

class Toast extends PureComponent {
  constructor (props) {
    super(props)
    this.autoDismissTimer = null
  }

  componentDidMount () {
    this.handleToastActive()
  }

  componentDidUpdate () {
    this.handleToastActive()
  }

  componentWillUnmount () {
    this.clearAutoDismissTimer()
  }

  handleToastActive () {
    const { toast } = this.props
    if (!toast.active) { return }

    // transition
    removeClass(this.toastBox, 'toast-active')
    setTimeout(() => addClass(this.toastBox, 'toast-active'), 30)

    // auto dismiss
    this.clearAutoDismissTimer()
    this.autoDismissTimer = setTimeout(() => {
      this.autoDismiss()
    }, 5000)
  }

  autoDismiss () {
    const { toast, switchToast } = this.props
    if (toast.active) {
      switchToast(false)
    }
  }

  clearAutoDismissTimer () {
    if (this.autoDismissTimer) {
      clearTimeout(this.autoDismissTimer)
    }
  }

  render () {
    const { toast, switchToast } = this.props
    const { type, iconType, content } = toast
    // type will be one of normal, advisory, warning
    return (
      <div
        className={style.toastBox}
        ref={(node) => { this.toastBox = node }}
      >
        <div className={style.toast}>
          <em className={`${style[type]} ${style.type}`}>
            <Icon
              name={iconType}
              className={style.toastIcon}
            />
          </em>
          <p className={style.content}>{content}</p>
          <button
            className={style.closeButton}
            onClick={event => switchToast(false)}
          >
            <Icon name='close' />
          </button>
        </div>
      </div>
    )
  }
}

export default Toast
